import Component from 'C:/Users/elkers/Desktop/firm/dev/szwl-wx-dev/components/DeviceCard.vue'
wx.createComponent(Component)